import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33c81276"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alert" }
const _hoisted_2 = { href: "/" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBarMenuItems = _resolveComponent("NavBarMenuItems")!
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheHeader, null, {
      "menu-list": _withCtx(() => [
        _createVNode(_component_NavBarMenuItems, { listItems: _ctx.ListItemsNavBarBankForm }, null, 8, ["listItems"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.ErrorConfiguration.text.error), 1),
      _createElementVNode("h3", null, _toDisplayString(_ctx.ErrorConfiguration.text.title), 1),
      _createElementVNode("p", null, [
        _createElementVNode("a", _hoisted_2, _toDisplayString(_ctx.ErrorConfiguration.text.text), 1)
      ])
    ]),
    _createVNode(_component_TheFooter)
  ], 64))
}